import { LangDetail } from 'ngx-core-services';

export const supportedLanguages: LangDetail[] = [{
    src: 'assets/images/flags/it.svg',
    id: 'it',
    locate: 'it-IT',
    name: 'i18n.Common.Italian',
  }, {
    src: 'assets/images/flags/en.svg',
    id: 'en',
    locate: 'en-US',
    name: 'i18n.Common.English',
  }, {
    src: 'assets/images/flags/de.svg',
    id: 'de',
    locate: 'de-DE',
    name: 'i18n.Common.German',
  }, {
    src: 'assets/images/flags/es.svg',
    id: 'es',
    locate: 'es-ES',
    name: 'i18n.Common.Spanish',
  }, {
    src: 'assets/images/flags/fr.svg',
    id: 'fr',
    locate: 'fr-FR',
    name: 'i18n.Common.French',
  }, {
    src: 'assets/images/flags/pl.svg',
    id: 'pl',
    locate: 'pl-PL',
    name: 'i18n.Common.Polish',
  }, {
    src: 'assets/images/flags/gr.svg',
    id: 'gr',
    locate: 'en-US',
    name: 'i18n.Common.Greek',
  }, {
    src: 'assets/images/flags/pt.svg',
    id: 'pt',
    locate: 'pt-PT',
    name: 'Portuguese',
  },
];
